var hours = [];
var hour = '';
const separateHour = 2;
for (var i = 0; i < 24*separateHour; i++) {
    hour = ((i < separateHour*10 ? '0' : '') + Math.round(i / separateHour - 0.001).toString() + ':' + (i % 2 == 0 ? '0' : '3') + '0').toString();
    hours.push({ value: i, label: hour });
}

const Time = {
    DefaultDateFrom: null,
    DefaultDateTo: null,
    Year: new Date().getFullYear(),
    Hours: hours,
}

export default Time;



// WEBPACK FOOTER //
// ./client/constants/Time.js